import { Link } from "react-router-dom";
export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="payment-cancel">
      <div className="text-center max-w-md">
        <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: "var(--gold)" }}>payment cancelled</p>
        <h1 className="font-serif text-4xl mb-4" style={{ color: "var(--ink)" }}>no charge made.</h1>
        <p className="mb-6" style={{ color: "var(--ink-soft)" }}>you can enrol whenever you&apos;re ready.</p>
        <Link to="/" className="btn-primary" data-testid="cancel-back">back to home</Link>
      </div>
    </div>
  );
}
